import React from "react";
import "./TourPackageData.css";
import NavbarSection from "../NavbarSection/NavbarSection";
import rajwadaindor from "../../assets/rajwadaindor.png";
import omkarshawar from "../../assets/omkarshawar.png";
import ujjain from "../../assets/ujjain.png";
import logo1 from "../../assets/logo1.png";
import { Link } from "react-router-dom";
import { useState } from "react";
    import { useLocation, useNavigate } from "react-router-dom";
import FooterSection from "../FooterSection/FooterSection";
const TourPackageData = () => {
  const [activeTab, setActiveTab] = useState("daywise");
 const location = useLocation();
 const navigate = useNavigate();

 // Getting package title from another component
 const packageName = location.state?.title || "ZikRme Dream Vacation";
  return (
    <div>
      <NavbarSection />
      <div className="trip-info">
        <h2 className="trip-title">{packageName}</h2>
        <p className="trip-days">3 Days and 2 Nights</p>
        <p className="trip-desc">
          Discover the winter magic with our exclusive 3N/2D expedition starting
          from Indore at just Rs.6,999! Book now
        </p>
      </div>
      <div className="tour-package-box">
        {/* Left Content */}
        <div className="tour-package-left">
          <div className="tour-header">
            <h2 className="trip-title">{packageName}</h2>
            <div className="view360-btnn" onclick="alert('360 View Clicked')">
              <div className="arrowes clockwiseee"></div>
              <div className="arrowes anticlockwiseee"></div>
              <div className="view360-texttt">360°</div>
            </div>
          </div>

          <div className="io-package-container">
            {/* Left Box */}
            <div className="io-package-box">
              <div className="io-header">
                <h2 className="trip-title">{packageName}</h2>
              </div>

              <div className="io-row">
                <span>DURATION :</span> 3 Days / 2 Nights
              </div>

              <div className="io-row">
                <span>ROUTE :</span> Indore – Ujjain – Omkareshwar – Indore
              </div>

              <div className="io-row no-border">
                <span>CATEGORY :</span> Madhya Pradesh Tours / Religious Tours
              </div>
            </div>

            {/* Right Images */}
            <div className="io-images">
              <div className="io-img-top">
                <img src={rajwadaindor} alt="" />
                <img src={omkarshawar} alt="" />
              </div>

              <div className="io-img-bottom">
                <img src={ujjain} alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="itinerary-container">
        {/* Tabs */}
        <div className="itinerary-tabs">
          <div
            className={`tab ${activeTab === "daywise" ? "active" : ""}`}
            onClick={() => setActiveTab("daywise")}
          >
            Day Wise Itinerary
          </div>

          <div
            className={`tab ${activeTab === "inclusion" ? "active" : ""}`}
            onClick={() => setActiveTab("inclusion")}
          >
            Inclusion
          </div>

          <div
            className={`tab ${activeTab === "exclusion" ? "active" : ""}`}
            onClick={() => setActiveTab("exclusion")}
          >
            Exclusion
          </div>
        </div>

        {/* Day Wise Itinerary */}
        {activeTab === "daywise" && (
          <div className="itinerary-box">
            {[...Array(15)].map((_, index) => (
              <div className="day-column" key={index}>
                <h3>
                  <span className="day-title">Day {index + 1}</span>
                  <span className="day-route"> Sample Route</span>
                </h3>

                <ul>
                  <li>Breakfast at hotel</li>
                  <li>Local sightseeing</li>
                  <li>Temple visit</li>
                  <li>Evening Aarti</li>
                  <li>Overnight stay</li>
                </ul>
              </div>
            ))}
          </div>
        )}

        {/* Inclusion */}
        {activeTab === "inclusion" && (
          <div className="itinerary-box">
            <ul>
              <li>Hotel Stay</li>
              <li>Breakfast & Dinner</li>
              <li>Transport</li>
              <li>Sightseeing</li>
            </ul>
          </div>
        )}

        {/* Exclusion */}
        {activeTab === "exclusion" && (
          <div className="itinerary-box">
            <ul>
              <li>Personal Expenses</li>
              <li>Entry Tickets</li>
              <li>Guide Charges</li>
            </ul>
          </div>
        )}
      </div>

      <div className="info-grid">
        {/* Highlights */}
        <div className="info-item">
          <div
            className={`tab ${activeTab === "highlights" ? "active" : ""}`}
            onClick={() => setActiveTab("highlights")}
          >
            <h3>Tour Highlights</h3>
          </div>

          {activeTab === "highlights" && (
            <div className="info-dropdown">
              <ul>
                <li>Mahakaleshwar Temple</li>
                <li>Omkareshwar Jyotirlinga</li>
                <li>Narmada Ghat</li>
              </ul>
            </div>
          )}
        </div>
        {/* Accommodation */}
        <div className="info-item">
          <div
            className={`tab ${activeTab === "accommodation" ? "active" : ""}`}
            onClick={() => setActiveTab("accommodation")}
          >
            <h3>Accommodation</h3>
          </div>

          {activeTab === "accommodation" && (
            <div className="info-dropdown">
              <ul>
                <li>3 Star Hotels</li>
                <li>Deluxe Rooms</li>
                <li>Attached Bathroom</li>
              </ul>
            </div>
          )}
        </div>

        {/* Transport */}
        <div className="info-item">
          <div
            className={`tab ${activeTab === "transport" ? "active" : ""}`}
            onClick={() => setActiveTab("transport")}
          >
            <h3>Transport</h3>
          </div>

          {activeTab === "transport" && (
            <div className="info-dropdown">
              <ul>
                <li>Private Cab</li>
                <li>Driver Included</li>
                <li>All Transfers</li>
              </ul>
            </div>
          )}
        </div>

        {/* Meals */}
        <div className="info-item">
          <div
            className={`tab ${activeTab === "meals" ? "active" : ""}`}
            onClick={() => setActiveTab("meals")}
          >
            <h3>Meals</h3>
          </div>

          {activeTab === "meals" && (
            <div className="info-dropdown">
              <ul>
                <li>Breakfast</li>
                <li>Dinner</li>
                <li>Tea</li>
              </ul>
            </div>
          )}
        </div>

        {/* Best Time */}
        <div className="info-item">
          <div
            className={`tab ${activeTab === "besttime" ? "active" : ""}`}
            onClick={() => setActiveTab("besttime")}
          >
            <h3>Best Time</h3>
          </div>

          {activeTab === "besttime" && (
            <div className="info-dropdown">
              <ul>
                <li>October to March</li>
                <li>Pleasant Weather</li>
                <li>Festival Time</li>
              </ul>
            </div>
          )}
        </div>

        {/* Tour Type */}
        <div className="info-item">
          <div
            className={`tab ${activeTab === "tourtype" ? "active" : ""}`}
            onClick={() => setActiveTab("tourtype")}
          >
            <h3>Tour Type</h3>
          </div>

          {activeTab === "tourtype" && (
            <div className="info-dropdown">
              <ul>
                <li>Religious</li>
                <li>Family</li>
                <li>Group</li>
              </ul>
            </div>
          )}
        </div>
      </div>
      <div className="pricing-section">
        <div className="pricing-box">
          <h2 className="pricing-title">Pricing Table</h2>

          <div className="pricing-row pricing-header">
            <div>Person</div>
            <div>Per/Person</div>
          </div>

          <div className="pricing-row">
            <div>1-2</div>
            <div>Rs.6,999</div>
          </div>

          <div className="pricing-row">
            <div>3-4</div>
            <div>Rs.9,999</div>
          </div>

          <div className="pricing-row">
            <div>5 or above</div>
            <div>Custom</div>
          </div>
        </div>

        <div className="pricing-buttons">
          <Link to="/book-now-info" state={{ title: packageName }}>
            <button className="price-btn">Book Now</button>
          </Link>
          <Link to="/enquiry-form">
            <button className="price-btn">Enquiry</button>
          </Link>
          <Link to="/travel-panning">
            <button className="price-btn">Request Call Back</button>
          </Link>
        </div>
      </div>
      <div className="why-section">
        <h2 className="why-title">Why Choose ZikRme?</h2>

        <ol className="why-list">
          <li>Trusted Local Partners</li>
          <li>Transparent Pricing</li>
          <li>24*7 Support</li>
          <li>Custom & Fixed Tours</li>
          <li>Budget To Luxury Options</li>
        </ol>
      </div>
      <div className="review-section">
        <h2 className="review-title">Customer Reviews</h2>

        {/* Review 1 */}
        <div className="review-row left">
          <img src={logo1} className="review-img" alt="" />
          <div className="review-text">
            <p>
              "Our Ujjain trip with ZikRme was smooth and affordable.
              ⭐⭐⭐⭐⭐"
            </p>
            <p>"Best service and quick support. ⭐⭐⭐⭐"</p>
          </div>
        </div>

        {/* Review 2 */}
        <div className="review-row right">
          <div className="review-text">
            <p>
              "Our Ujjain trip with ZikRme was smooth and affordable.
              ⭐⭐⭐⭐⭐"
            </p>
          </div>
          <img src={logo1} className="review-img" alt="" />
        </div>

        {/* Review 3 */}
        <div className="review-row left">
          <img src={logo1} className="review-img" alt="" />
          <div className="review-text">
            <p>
              "Our Ujjain trip with ZikRme was smooth and affordable.
              ⭐⭐⭐⭐⭐"
            </p>
            <p>"Best service and quick support. ⭐⭐⭐⭐"</p>
          </div>
        </div>

        {/* Call To Action */}
        <div className="cta-section">
          <h2 className="cta-title">Call To Action</h2>
          <p className="cta-text">Plan Your Next Trip With ZikRme</p>

          <div className="cta-buttons">
            <Link to="/book-now-info" state={{ title: packageName }}>
              <button className="cta-btn">Book Now</button>
            </Link>
            <button className="cta-btn">Get Best Deal</button>
          </div>
        </div>
      </div>
      <FooterSection />
    </div>
  );
};

export default TourPackageData;
